import { module } from 'stereomodularjs';
import svgIco from '../components/svgIco.vue'
import NewCarSpecs from '../components/NewCarSpecs.vue'
import { createApp } from "vue/dist/vue.esm-bundler.js"

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        const app = createApp({
            template: '<NewCarSpecs />',
            components: { svgIco, NewCarSpecs },
            data() {
                return {
                    spriteURL: self.el.dataset.sprite
                }
            }
        })

        app.component("svgIco", svgIco)

        app.mount(self.el)
       

    }
}
